/**
 * 病例管理 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const caseRoute = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "case-manage",
    meta: {
      title: "病例管理",
      icon: "icon-case",
    },
    children: [
      {
        path: "/activity/manage",
        name: "ActivityManage",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/caseManage/activityManage"
          ),
        meta: {
          title: "活动管理",
          icon: "home",
        },
      },
      // {
      //   path: "/activity/create",
      //   name: "ActivityCreate",
      //   hidden: true,
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "about" */ "@/pages/caseManage/activityManage/createActivity.vue"
      //     ),
      //   meta: {
      //     title: "创建活动",
      //     icon: "home",
      //   },
      // },
      // {
      //   path: "/activity/edit",
      //   name: "ActivityEdit",
      //   hidden: true,
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "about" */ "@/pages/caseManage/activityManage/createActivity.vue"
      //     ),
      //   meta: {
      //     title: "编辑活动",
      //     icon: "home",
      //   },
      // },
      {
        path: "/case/list",
        name: "CaseList",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/pages/caseManage/caseReview"
          ),
        meta: {
          title: "病例审核",
          icon: "home",
        },
      },
    ],
  },
];
export default caseRoute;
